const config = {
    "validation-server": "http://172.27.63.177:8888",
    "strapi-server": "http://172.27.63.177:1337"
};

export default config;